<template>
  <div class="app-tab-container">
    <div class="left-arrow" @click="left"><i class="el-icon-arrow-left"></i></div>
    <div class="tab-container">
      <div @click="open(tab.address)" v-for="(tab, i) in tabs" :key="i" :class="active === tab.address ? 'app-tab-active' : ''">{{tab.name}}<span class="el-icon-close" @click.stop.prevent="close(tab.address)" v-if="tab.closable !== false"></span></div>
    </div>
    <div class="right-arrow" @click="right"><i class="el-icon-arrow-right"></i></div>
  </div>
</template>

<script>
export default {
  name: 'app-tab',
  data () {
    return {
      tabs: [{ address: '/', name: '首页', closable: false }],
      active: '/',
      menuMap: {}
    }
  },
  created () {
    let menus = this.$store.state.admin.menus || []
    let menuMap = {}
    this.initMenuMap(menus, menuMap)
    this.menuMap = menuMap

    let paths = location.href.split('#')
    if (paths.length > 1) {
      let path = paths[1]
      if (path.indexOf('?') !== -1) {
        path = path.split('?')[0]
      }
      if (path.indexOf('&') !== -1) {
        path = path.split('&')[0]
      }
      if (path && path !== '/') {
        this.open(path, false)
      }
    }
  },
  methods: {
    initMenuMap (menus, menuMap) {
      for (let menu of menus) {
        menuMap[menu.address] = menu.name
        if (menu.children && menu.children.length) {
          this.initMenuMap(menu.children, menuMap)
        }
      }
    },
    open (address, triggerRoute) {
      let tabs = this.tabs
      for (let tab of tabs) {
        if (tab.address === address) {
          this.active = address
          this.$router.push({ path: address })
          return
        }
      }
      tabs.push({
        address: address,
        name: this.menuMap[address] || ''
      })
      this.tabs = tabs
      this.active = address
      if (triggerRoute !== false) {
        this.$router.push({ path: address })
      }
    },
    close (address) {
      let tabs = this.tabs
      for (let i = 0; i < tabs.length; i++) {
        let tab = tabs[i]
        if (tab.address === address) {
          tabs.splice(i, 1)
          if (this.active === address) {
            if (tabs.length > i) {
              this.active = tabs[i].address
            } else {
              this.active = tabs[tabs.length - 1].address
            }
            this.$router.push({ path: this.active })
          }
          this.tabs = tabs
          return
        }
      }
    },
    left () {
      document.querySelector('.tab-container').scrollLeft -= 200
    },
    right () {
      document.querySelector('.tab-container').scrollLeft += 200
    }
  }
}
</script>

<style lang='less' scoped>
.app-tab-container {
  height:40px;
  line-height:39px;
  border:1px solid #e4e7ed;
  box-sizing:border-box;
  font-size:14px;
  font-weight:500;
  color:#303133;
  margin:16px 8px 0;
  >div {
    float:left;
    :hover{color:#409eff;}
    >div {
      display:inline-block;
      border-right:1px solid #e4e7ed;
      padding:0 16px;
      position:relative;
      cursor:pointer;
      transition:color .3s cubic-bezier(.645,.045,.355,1);

      .el-icon-close{margin-left:6px;transform:scale(.9);border-radius:50%;transition:all .3s cubic-bezier(.645,.045,.355,1);}
      .el-icon-close:hover{background-color:#c0c4cc;color:#fff;}
    }
    >div.app-tab-active{color:#409eff;}
    >div.app-tab-active:after{content:' ';width:100%;position:absolute;left:0;bottom:0;border-bottom:1px solid #fff;}
    >div:first-child{margin-left:1px;}
    >div:first-child.app-tab-active{margin-left:0;border-left:1px solid #e4e7ed;}
  }
  >div.tab-container {overflow:hidden;white-space:nowrap;width:calc(100% - 60px);}
  >div.left-arrow, >div.right-arrow {width:30px;box-sizing:border-box;text-align:center;cursor:pointer;}
}
</style>
